import { RootStoreState } from '@/store';
import { ActionContext, Module } from 'vuex';
import ApiServiceWrapper from '@/shared/api-request.service';

export interface BetaProgramStoreState {
  betaProgram:[];
}

export default {
  state:{
    betaProgram:[],
  },
  mutations:{
  },
  actions:{
    async getBetaProgrqam(context: ActionContext<BetaProgramStoreState, RootStoreState>, userId:any) {
      context.commit('startLoading', null, { root: true });
      const endpoint = `betaprogram/get-beta-program?username=${userId}`;
      return ApiServiceWrapper.get(endpoint);
    },
    async getBetaProgramDetails(context: ActionContext<BetaProgramStoreState, RootStoreState>, selectedProgramDetails:any) {
      context.commit('startLoading', null, { root: true });
      const endpoint = `betaprogram/get-beta-program-detail?surveyproductserviceid=${selectedProgramDetails.id}&betaSwId=${selectedProgramDetails.betaSwId}`;
      return ApiServiceWrapper.get(endpoint);
    },
    async uploadSurveyData(context: ActionContext<BetaProgramStoreState, RootStoreState>, payload:any) {
      context.commit('startLoading', null, { root: true });
      const endpoint = 'betaprogram/survey-answer';
      return ApiServiceWrapper.post(endpoint, payload);
    },
  },
  getters:{
    getBetaProgram(state) {
      return state.betaProgram;
    },
  },
  namespaced: true,
} as Module<BetaProgramStoreState, RootStoreState>;
